import GroupLayout from "./GroupLayout";

const adiayabirlaLayout = () => (
  <GroupLayout
    brandName="Aditya Birla Public School"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.dev/image_2023_11_27T11_44_22_517Z.png"
    groupId="10000000047"
    headline="ABPS Group "
  />
);

export default adiayabirlaLayout;
